import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=59b0706e&"
import script from "./NewsCreate.vue?vue&type=script&lang=js&"
export * from "./NewsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports